// Author THQ
// Date 2025-03-09 09:58:18

import * as model from "@/model/em/ppe/PpeInventoryModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeInventory(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
    })
    .buildStore()
